import styled from "vue-styled-components";

export const CFooterDescripition = styled.div`
    background-color: ${props => props.theme?.footer?.background_color ?? '#fff'};
    color: ${props => props.theme?.footer?.color ?? '#3c3232'};
    font-weight: ${props => props.theme?.footer?.font_weight ?? 400};
    > .footer-description {
        padding: 20px 30px;
        text-align: center;
    }
`;

export const CFooterNewsletter = styled.div`
    background-color: ${props => props.theme?.footer?.newsletter?.background_color ?? '#bdbdbd'};
    display: flex;
    justify-content: center;
`;

export const CTitleNewsletter = styled.div`
    margin: 10px 0;
    display: flex;
    flex-direction: column;

    > h3 {
        margin-bottom: 15px;
        color: ${props => props.theme?.footer?.newsletter?.title_color ?? '#3c3232'};
        letter-spacing: 0.05em;
        text-transform: ${props => props.theme?.footer?.text_transform_title ?? 'uppercase'};
        margin-top: 0px;
        margin-bottom: 1.6rem;
        font: ${props => props.theme?.footer?.newsletter?.font_weight_title ?? 400} ${props => props.theme?.footer?.title_font_size ?? '1.5rem / 1.1'} ${props => props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif; // Oswald
        
        > i {
            color: ${props => props.theme?.footer?.newsletter?.title_color ?? '#3c3232'};
            font-size: ${props => props.theme?.footer?.newsletter?.font_size_icons ?? '20px'};
            margin-right: 5px;
        }
    }

    > p {
        color: ${props => props.theme?.footer?.newsletter?.color ?? '#bdbdbd'};
        font-weight: ${props => props.theme?.footer?.newsletter?.font_weight ?? 400};
        margin-top: 0;
        margin-bottom: 0;
    }

    @media screen and (min-width: 992px) {
        margin: 10px 0;
        flex-direction: row;
        align-items: center;
        > h3 {
            margin-bottom: 0px;
            margin-right: 20px;
        }
    }
`;

export const CSocialMediaNewsletter = styled.div`
    padding-left: 0;
    padding-right: 0;
    margin: 10px 0;
    display: flex;
    align-items: center;

    > .social-media-icon {
        margin: 0 -5px;
        > .social-icons { 
            display: -ms-flexbox;
            display: flex;
            flex-wrap: wrap;
            -ms-flex-align: center;
            align-items: center; 
            > .social-icon {
                display: -ms-inline-flexbox;
                display: inline-flex;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-pack: center;
                justify-content: center;
                width: auto;
                height: 2.5rem;
                color: ${props => props.theme?.footer?.newsletter?.color_icons ?? '#fff'};
                text-decoration: none;
                opacity: 1; 
                margin: 3px 5px;
                &:hover, &:focus {
                    color: ${props => props.theme?.footer?.newsletter?.color_hover_icons ?? '#3c3232'} !important;
                } 
                > i {
                    font-size: ${props => props.theme?.footer?.newsletter?.font_size_icons ?? '20px'};
                    &::before {
                        width: auto;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 768px) {
        justify-content: flex-end;
        > .social-media-icon {
            margin-left: 10px;
        } 
    }
`;

export const CFooterPayments = styled.div`
    display: flex;
    justify-content: center;
    /* margin-top: 30px; */
    background-color: rgba(128, 134, 138, 0.116);
`;

export const CFooterPaymentsCol = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 20px;
    > .title-footer {
        color: ${props => props.theme?.footer?.title_color_payments ?? props.theme.primary_color};
        letter-spacing: 0.05em;
        text-transform: ${props => props.theme?.footer?.text_transform_title ?? 'uppercase'};
        margin-top: 20px;
        margin-bottom: 1.8rem;
        font: ${props => props.theme?.footer?.newsletter?.font_weight_title ?? 400} ${props => props.theme?.footer?.title_font_size ?? '1.5rem'} / 1.1 ${props => props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif !important;
    }
    > a {
        color: ${props => props.theme?.footer?.title_color_payments ?? props.theme.primary_color};
        &:hover {
            color: ${props => props.theme?.footer?.title_color_payments ?? props.theme.primary_color};
        }
    }
`;

export const CWidgetTitle = styled.h4`
    color: rgb(40, 45, 59);
    letter-spacing: 0.05em;
    text-transform: ${props => props.theme?.footer?.text_transform_title ?? 'uppercase'};
    /* margin-top: 0px; */
    margin-bottom: 2.4rem;
    font: ${props => props.theme?.footer?.newsletter?.font_weight_title ?? 400} ${props => props.theme?.footer?.title_font_size ?? '1.5rem'} / 1.1 ${props => props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif;
    &::first-letter {
        text-transform: uppercase;
    }
`;

export const CContactInfoLabel = styled.span`
    display: block;
    font-weight: ${props => props.theme?.footer?.newsletter?.font_weight_title ?? 400};
    font-size: ${props => props.theme?.footer?.contact?.title_font_size ?? '1.3rem'};
    font-family: ${props => props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif; 
    color: #000;
    text-transform: ${props => props.theme?.footer?.text_transform_title ?? 'uppercase'};
    margin-bottom: .3rem;
    letter-spacing: .02em;
`;